<template>
  <div>
    <component :is="subtaskType"></component>
    <hr class="non-share">
    <component :is="subtaskControls" class="mb-3 non-share"></component>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  RevealImageControls, RevealImage, TimerControls, Timer,
} from './index';

export default {
  components: {
    RevealImageControls, RevealImage, TimerControls, Timer,
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      subtaskLimit: 10,
      completedCount: 0,
    };
  },

  computed: {
    ...mapState(['visualSchedule', 'subtaskCounterOptions', 'userId']),

    subtaskId() {
      return this.visualSchedule.visual_schedule_subtask_id;
    },

    subtaskType() {
      let component;
      const subtask = this.subtaskCounterOptions.find((st) => st.id === this.visualSchedule.visual_schedule_subtask_id);
      if (subtask.name.includes('Image')) {
        component = 'RevealImage';
      } else if (subtask.name !== 'None') {
        component = 'Timer';
      }
      return component;
    },

    subtaskControls() {
      return `${this.subtaskType}Controls`;
    },
  },

  methods: {
    ...mapMutations(['updateVisualSchedule', 'updateCardPositions']),

    handleSubtaskLimit(val) {
      this.subtaskLimit = val;
    },

    handleCompletedCount(val) {
      this.completedCount = val;
    },
  },
};
</script>
